import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";


export default function Mybikerentalpackage({
  selectedRow,
  rentalPackages,
  setGroupsList,
  groupsList,
  getGroupsAPI,
  vehicleProfileData,
  getVehicleProfileRentalPackagesAPI,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [rows, setRows] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [addNewpackage, setAddNewPackage] = useState(false);

  // Sync props → local state
  useEffect(() => {
    setRows(rentalPackages || []);
  }, [rentalPackages]);

  const cancelEdit = () => {
    setEditingRowId(null);
    setEditForm({});
    setAddNewPackage(false);
  };

  const saveEdit = async () => {
    const payload = {
      id: editForm?.id,
      packageName: editForm.packageName,
      minDayCount : Number(editForm.minDayCount),
      minHrs: Number(editForm.minHrs),
      kmPerDay: Number(editForm.kmPerDay),
      extraKmCost: Number(editForm.extraKmCost),
      extraHrCost: Number(editForm.extraHrCost),
      costPerDay: Number(editForm.costPerDay),
      costPerHr: Number(editForm?.costPerHr),
      groupId: vehicleProfileData[0].vehicleGroupId,
    };

    try {
      const response = await fetch(`${apiUrl}/api/bikerentalpackages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("Vehicle package detail Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        await getVehicleProfileRentalPackagesAPI(
          vehicleProfileData[0]?.vehicleGroupId,
        );

        setEditingRowId(null);
        setEditForm({});
        setAddNewPackage(false);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const startEdit = (pkg) => {
    if (editingRowId) return; // block multi-edit
    setEditingRowId(pkg.id);
    setEditForm({ ...pkg });
  };

  const handleChange = (field, value) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="p-6">
      <div className="flex justify-between">
        <div className="flex gap-2">
          <div className="h-5 w-1 rounded bg-teal-600"></div>
          <h2 className="text-lg font-semibold text-slate-800">
            My Bike Rental Package
          </h2>
        </div>
        {!addNewpackage && !editingRowId && rentalPackages?.length === 0 && (
          <Button
            variant="contained"
            onClick={() => {
              setEditForm({
                packageName: "",
                minDayCount: "",
                minHrs: "",
                kmPerDay: "",
                extraKmCost: "",
                extraHrCost: "",
                costPerDay: "",
                costPerHr: "",
              });
              setAddNewPackage(true);
            }}
          >
            Add Bike Rental Package
          </Button>
        )}
      </div>
      <table className="w-full border border-gray-300 text-sm mt-4">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">Package Name</th>
            <th className="border px-2 py-1">Minimum Day</th>
            <th className="border px-2 py-1">Minimum Hrs</th>
            <th className="border px-2 py-1">Km / day</th>
            <th className="border px-2 py-1">Extra Km Cost</th>
            <th className="border px-2 py-1">Extra Hr Cost</th>
            <th className="border px-2 py-1">Cost / Day</th>
            <th className="border px-2 py-1">Cost / Hr</th>
            <th className="border px-2 py-1">Group</th>
            <th className="border px-2 py-1">Created On</th>
            <th className="border px-2 py-1">Action</th>
          </tr>
        </thead>

        <tbody>
          {addNewpackage && (
            <tr className="border-t">
              <td className="border px-2 py-1 text-center">
                <input
                  className="border px-1 w-full"
                  value={editForm.packageName ?? ""}
                  onChange={(e) => handleChange("packageName", e.target.value)}
                />
              </td>
              <td className="border px-2 py-1 text-center">
                <input
                  type="number"
                  className="border px-1 w-full"
                  value={editForm.minDayCount ?? ""}
                  onChange={(e) =>
                    handleChange("minDayCount", Number(e.target.value))
                  }
                />
              </td>
              {[
                "minHrs",
                "kmPerDay",
                "extraKmCost",
                "extraHrCost",
                "costPerDay",
                "costPerHr",
              ].map((field) => (
                <td className="border px-2 py-1 text-center" key={field}>
                  <input
                    type="number"
                    className="border px-1 w-full"
                    value={editForm[field] ?? ""}
                    onChange={(e) =>
                      handleChange(field, Number(e.target.value))
                    }
                  />
                </td>
              ))}
              <td className="border px-2 py-1 text-center">
                {
                  groupsList.find(
                    (item) => item?.id === vehicleProfileData[0]?.vehicleGroupId,
                  )?.name
                }
              </td>
              <td className="border px-2 py-1 text-center">-</td>
              <td className="border px-2 py-1 text-center">
                <button
                  onClick={saveEdit}
                  className="bg-green-500 text-white px-2 py-1 mr-2"
                >
                  Save
                </button>
                <button
                  onClick={cancelEdit}
                  className="bg-gray-400 text-white px-2 py-1"
                >
                  Cancel
                </button>
              </td>
            </tr>
          )}
          {rows && rows.length > 0 ? (
            rows.map((pkg) => {
              const isEditing = editingRowId === pkg.id;

              return (
                <tr key={pkg.id} className="border-t">
                  {/* Name */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        className="border px-1 w-full"
                        value={editForm.packageName ?? ""}
                        onChange={(e) => handleChange("packageName", e.target.value)}
                      />
                    ) : (
                      pkg.packageName
                    )}
                  </td>

                  {/* Total Free Km */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.minDayCount ?? ""}
                        disabled
                        onChange={(e) =>
                          handleChange("minDayCount", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.minDayCount
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.minHrs ?? ""}
                        onChange={(e) =>
                          handleChange("minHrs", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.minHrs
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.kmPerDay ?? ""}
                        onChange={(e) =>
                          handleChange("kmPerDay", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.kmPerDay
                    )}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.extraKmCost ?? ""}
                        onChange={(e) =>
                          handleChange("extraKmCost", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.extraKmCost
                    )}
                  </td>

                  {/* Weekday Tariff */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.extraHrCost ?? ""}
                        onChange={(e) =>
                          handleChange("extraHrCost", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.extraHrCost
                    )}
                  </td>

                  {/* Weekend Tariff */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.costPerDay ?? ""}
                        onChange={(e) =>
                          handleChange("costPerDay", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.costPerDay
                    )}
                  </td>  

                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <input
                        type="number"
                        className="border px-1 w-full"
                        value={editForm.costPerHr ?? ""}
                        onChange={(e) =>
                          handleChange("costPerHr", Number(e.target.value))
                        }
                      />
                    ) : (
                      pkg.costPerHr
                    )}
                  </td>                 

                  <td className="border px-2 py-1 text-center">
                    {
                      groupsList.filter((item) => item?.id === pkg.groupId)[0]
                        ?.name
                    }
                  </td>

                  {/* Created On */}
                  <td className="border px-2 py-1 text-center">
                    {pkg.createdAt}
                  </td>

                  {/* Action */}
                  <td className="border px-2 py-1 text-center">
                    {isEditing ? (
                      <>
                        <button
                          onClick={saveEdit}
                          className="bg-green-500 text-white px-2 py-1 mr-2"
                        >
                          Save
                        </button>
                        <button
                          onClick={cancelEdit}
                          className="bg-gray-400 text-white px-2 py-1"
                        >
                          Cancel
                        </button>
                      </>
                    ) : !addNewpackage ? (
                      <button
                        onClick={() => startEdit(pkg)}
                        className="bg-blue-500 text-white px-2 py-1"
                      >
                        Edit
                      </button>
                    ) : null}
                  </td>
                </tr>
              );
            })
          ) : (
            !addNewpackage && (
              <tr>
                <td colSpan={11} className="text-center mt-4 font-semibold">
                  No Package Details Found
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
}
